export default {
    title: 'Innovation field',
    export: 'export',
    megatrends: 'Mega-trends',
    macrotrends: 'Macro-trends',
    microtrends: 'Micro-trends',
    delete: 'The trend was successfully deleted.',
    pageTitle: 'VIEW - INNOVATION FIELDS'
}
